const CATEGORY_LABEL_KEYS = {
  length: 'admin.suggestions_filter_length',
  texture: 'admin.suggestions_filter_texture',
  vibe: 'admin.suggestions_filter_vibe'
};

const OPTION_LABEL_KEYS = {
  short: 'admin.suggestions_option_short',
  medium: 'admin.suggestions_option_medium',
  long: 'admin.suggestions_option_long',
  'extra-long': 'admin.suggestions_option_extra_long',
  straight: 'admin.suggestions_option_straight',
  wavy: 'admin.suggestions_option_wavy',
  curly: 'admin.suggestions_option_curly',
  coily: 'admin.suggestions_option_coily',
  clean: 'admin.suggestions_option_clean',
  'lived-in': 'admin.suggestions_option_lived_in',
  'classic-modern': 'admin.suggestions_option_classic_modern',
  statement: 'admin.suggestions_option_statement',
  elegant: 'admin.suggestions_option_elegant',
  casual: 'admin.suggestions_option_casual',
  edgy: 'admin.suggestions_option_edgy',
  romantic: 'admin.suggestions_option_romantic',
  professional: 'admin.suggestions_option_professional'
};

export const getSuggestionsCategoryLabel = (category, t) =>
  t(CATEGORY_LABEL_KEYS[category] || category, { defaultValue: category });

export const getSuggestionsOptionLabel = (option, t) =>
  t(OPTION_LABEL_KEYS[option] || option, { defaultValue: option });
